module.exports = __webpack_public_path__ + "img/编组2.c51cefff.png";